import { createAsyncThunk } from '@reduxjs/toolkit';
import getHistoryChunk, { getEmojiUpdateInterval } from './accessors';
import { createChunk } from './createChunk';
import interpolate from 'lib/interpolate';

export const fetchHistory = createAsyncThunk(
  'emoji/fetch-history',
  function (arg, thunkAPI) {
    const state = thunkAPI.getState();
    const updateInterval = getEmojiUpdateInterval(state);
    const chunk = createChunk(arg.position, updateInterval);
    const url = state.extensions.find(({ name }) => name === 'emoji').options
      .history;

    return thunkAPI.extra.interactiveAPI
      .query(
        interpolate(url, {
          from: chunk.from,
          to: chunk.to,
        }),
      )
      .then((data) => thunkAPI.fulfillWithValue(data, { chunk }));
  },
  {
    getPendingMeta({ arg, requestId: _requestId }, { getState }) {
      const state = getState();
      const updateInterval = getEmojiUpdateInterval(state);
      const chunk = createChunk(arg.position, updateInterval);

      return {
        chunk,
      };
    },
    condition: (args, { getState }) => {
      const state = getState();
      const chunk = getHistoryChunk(state, args.position);
      /* only when:
       *   - emoji is enabled for current object
       *   - current position is not in live, e.g. we do not listen MNS
       *   - no chunk for position
       *   - chunk outdated
       *   - chunk was rejected
       * */
      if (!state.emoji.enabled) {
        return false;
      }
      if (!state.extensions.find(({ name }) => name === 'emoji')?.consumable) {
        return false;
      }

      if (state.video.isLive) {
        return false;
      }

      if (chunk?.fetchStatus === 'pending') {
        return false;
      }

      if (chunk?.fetchStatus === 'success') {
        return Date.now() - chunk?.timestamp > 300_000;
      }

      return true;
    },
  },
);

/*

// too expensive

export const scheduleInvalidateChunk = createAsyncThunk(
	'emoji/history/invalidateChunk',
	function (requestAction, thunkAPI) {
		// debugger;
		const {
			meta: { requestId },
		} = requestAction;
		const state = thunkAPI.getState();

		const updateInterval = getEmojiUpdateInterval(state);

		return new Promise(resolve => {
			setTimeout(resolve, updateInterval * 1e3, requestId);
		});
	},
);
*/
